import { render } from "./ZoomCallPage.vue?vue&type=template&id=a62f770c"
import script from "./ZoomCallPage.vue?vue&type=script&lang=js"
export * from "./ZoomCallPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__